import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_USER } from './mutations';

export const useUpdateUser = (options?: MutationHookOptions) => useMutation(UPDATE_USER, options);
